import { render, staticRenderFns } from "./CounselingForm.vue?vue&type=template&id=97eca444&scoped=true"
import script from "./CounselingForm.vue?vue&type=script&lang=js"
export * from "./CounselingForm.vue?vue&type=script&lang=js"
import style0 from "./CounselingForm.vue?vue&type=style&index=0&id=97eca444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97eca444",
  null
  
)

export default component.exports